var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5001V19.0001C2 19.5305 2.21071 20.0392 2.58579 20.4143C2.96086 20.7893 3.46957 21.0001 4 21.0001H16C16.5304 21.0001 17.0391 20.7893 17.4142 20.4143C17.7893 20.0392 18 19.5305 18 19.0001V15.5001M1 13.0001V12.0001C1 11.4696 1.21071 10.9609 1.58579 10.5858C1.96086 10.2108 2.46957 10.0001 3 10.0001H17C17.5304 10.0001 18.0391 10.2108 18.4142 10.5858C18.7893 10.9609 19 11.4696 19 12.0001V13.0001M10 7.00006V10.0001M10 7.00006C11.262 7.00006 12 6.03206 12 4.37506C12 2.71806 10 1.00006 10 1.00006C10 1.00006 8 2.71806 8 4.37506C8 6.03206 8.738 7.00006 10 7.00006Z",
    stroke: "#5C5CAB",
    strokeOpacity: 0.3,
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 13.0001C1.00012 13.7957 1.31619 14.5588 1.8788 15.1214C2.44141 15.684 3.20447 16.0001 4.00012 16.0001C4.79577 16.0001 5.55883 15.684 6.12144 15.1214C6.68405 14.5588 7.00012 13.7957 7.00012 13.0001C7.00012 13.7957 7.31619 14.5588 7.8788 15.1214C8.44141 15.684 9.20447 16.0001 10.0001 16.0001C10.7958 16.0001 11.5588 15.684 12.1214 15.1214C12.6841 14.5588 13.0001 13.7957 13.0001 13.0001C13.0001 13.7957 13.3162 14.5588 13.8788 15.1214C14.4414 15.684 15.2045 16.0001 16.0001 16.0001C16.7958 16.0001 17.5588 15.684 18.1214 15.1214C18.6841 14.5588 19.0001 13.7957 19.0001 13.0001",
    stroke: "#5C5CAB",
    strokeOpacity: 0.3,
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientage);
export default __webpack_public_path__ + "static/media/patientage.e32c2b4c0152780416feb566b5592f92.svg";
export { ForwardRef as ReactComponent };